<template>
  <a-alert
    v-if="activeStubs.length > 0"
    type="warning"
    :message="`Stub mode active: ${activeStubs.join(', ')}`"
    banner
    style="
      text-align: center;
      position: sticky;
      top: 0;
      z-index: 999;
      width: 100%;
    "
  />
</template>

<script>
export default {
  data() {
    return {
      activeStubs: [],
    };
  },

  mounted() {
    const meta = document.querySelector('meta[name="stub-mode"]');

    this.activeStubs = meta ? meta.content.split(",") : [];
  },
};
</script>
